import { AppConfigNames, AppConfigTwoFactor } from "@lib/types/AppConfig";
import { useIntl } from "react-intl";
import { Form, Switch } from "antd";
import { AppLoader, AppsContainer } from "@lib/components/AppComponents";
import { useQuery } from "@tanstack/react-query";
import { apiGetAppConfigs } from "@lib/api/settings";
import { useAppConfigQueries } from "@lib/apiQueries";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const configName = AppConfigNames.twoFactorAuthConfig;

export default function TwoFactorAuthConfig() {
  const [form] = Form.useForm();
  const { messages } = useIntl();

  const { data, isLoading, isPending, refetch } = useQuery({
    queryFn: () =>
      apiGetAppConfigs({
        filter: [`name||eq||${configName}`],
      }),
    queryKey: ["app-config", configName],
  });

  const { updateAppConfigMutation } = useAppConfigQueries({
    messages,
    params: {
      sort: "createdAt,DESC",
    },
  });

  const loading = isLoading || isPending;
  const configId = data?.data?.data[0]?.id;
  const apiData = data?.data?.data[0]?.data as AppConfigTwoFactor;

  if (loading) return <AppLoader />;

  return (
    <AppsContainer
      fullView={true}
      cardBg
      title={messages["sidebar.twoFactorAuthConfig"] as string}
      cardStyle={{
        padding: 20,
      }}
      cardProps={{
        borderFull: true,
      }}
    >
      <Form {...layout} form={form} initialValues={{ ...data }}>
        <Form.Item
          name={"shouldApplyAdmin"}
          label={messages["common.shouldApplyAdmin"] as string}
        >
          <Switch
            loading={loading}
            disabled={loading}
            checked={apiData?.shouldApplyAdmin}
            onChange={async (status) => {
              await updateAppConfigMutation.mutateAsync({
                id: configId,
                data: {
                  ...apiData,
                  shouldApplyAdmin: status,
                },
                enabled: status,
              });
              refetch();
            }}
            checkedChildren={messages["common.enabled"] as string}
            unCheckedChildren={messages["common.disabled"] as string}
          />
        </Form.Item>
      </Form>
    </AppsContainer>
  );
}
